<template>
  <div class="gutter-top">
    <div v-if="serviceDeployed && serviceDeployed.enabled">
      <slot></slot>
    </div>

    <div class="text-center" v-if="serviceDeployed && !serviceDeployed.enabled">
      <h4>This service has not been deployed</h4>

      <template v-if="serviceDeployed.reason">
        <h5 class="text-muted no-margin-btm">Reason</h5>
        <p v-if="serviceDeployed.reason">
          {{ serviceDeployed.reason.label }}
        </p>
      </template>

      <button
        type="button"
        class="btn btn-primary btn-xs half-gutter-bottom"
        v-if="hasPermission(reDeployPermission)"
        v-on:click.prevent="deployService"
      >
        Deploy Service
      </button>
    </div>

    <div v-if="selectedService && typeof serviceDeployed === 'undefined'">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <toggle-group
              label="Do you want to deploy this service?"
              :required="true"
              :options="options"
              v-model="form.enabled"
              @input="toggleReasons"
            ></toggle-group>

            <selectlist
              name="type"
              placeholder="Please Select"
              v-model="form.reason_id"
              label="Reason"
              helper="Please select the reason you do not want to deploy this service"
              :options="selectedService.reasons"
              :required="true"
              :stack="true"
              :show-error="form.errors.has('reason_id')"
              label-name="label"
              :error-message="form.errors.get('reason_id')"
              key-name="id"
              v-if="
                !form.enabled &&
                  displayReasons &&
                  selectedService.reasons.length
              "
            ></selectlist>
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <form-button
          :indicator="form.processing()"
          v-on:clicked="submit"
          v-if="!readonly"
        >
          Save
        </form-button>
      </div>
    </div>
  </div>
</template>
<script>
import ToggleGroup from './../../../Generic/ToggleGroup';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    service: {
      type: String,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'toggle-group': ToggleGroup
  },

  data() {
    return {
      selectedService: undefined,
      serviceDeployed: undefined,
      form: new window.Form({
        service_id: null,
        enabled: false,
        reason_id: null
      }),
      displayReasons: false,
      options: [
        {
          value: true,
          label: 'Yes',
          highlight: 'btn-success'
        },
        {
          value: false,
          label: 'No',
          highlight: 'btn-danger'
        }
      ]
    };
  },

  computed: {
    deployedServices() {
      return this.$store.getters['Incident/services'];
    },

    reDeployPermission() {
      return `services.redeploy.${this.selectedService.name}`;
    }
  },

  mounted() {
    this.selectedService = this.services.find(
      service => service.name === this.service
    );

    if (this.selectedService) {
      this.form.service_id = this.selectedService.id;

      this.checkIfServiceHasBeenDeployed();
    }
  },

  methods: {
    toggleReasons(enabled) {
      this.displayReasons = !enabled;

      if (enabled) {
        this.form.reason_id = null;
      }
    },

    checkIfServiceHasBeenDeployed() {
      if (this.deployedServices && this.deployedServices.length) {
        this.serviceDeployed = this.deployedServices.find(
          service => service.service_id === this.selectedService?.id
        );
      }
    },

    deployService() {
      window
        .swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to deploy that service?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(() => {
          this.form.enabled = true;
          this.form.reason_id = null;

          this.submit();
        });
    },

    submit() {
      this.form
        .post(`/incidents/${this.incident}/services`)
        .then(response => {
          this.$store.commit('Incident/setServices', response);

          window.toastify.success('Saved', 'The service was updated.');
        })
        .catch(error => {
          window.toastify.error('Error', 'Please fill out the required fields');
        });
    }
  },

  watch: {
    deployedServices() {
      this.checkIfServiceHasBeenDeployed();
    }
  }
};
</script>
